import React from 'react';
import IconeContato from '../../assets/icone-contato.svg';
import IconeManual from '../../assets/icone-manual.svg';
import IconePrimeirosPassos from '../../assets/icone-primeiros-passos.svg';
import IconeSobreAPP from '../../assets/icone-sobre-a-PP.svg';
import HelpCard from '../../components/helpCard';
import './style.css';
import Card from '../../components/card';

const Help = () => (
  <div id="help-page">
    <h1 id="page-title">Ajuda</h1>
    <div id="container-grid">
      <HelpCard title="Contate-nos" logo={IconeContato}>
        <div className="text-card">
          <p>Converse com nosso time por um dos canais de atendimento:</p>
          <p style={{ whiteSpace: 'nowrap' }}>
            Email:&nbsp;
            <a
              className="link-inline"
              href="mailto: paiva@paiva.com.br"
              target="_blank"
              rel="noopener noreferrer"
            >
              paiva@paiva.com.br
            </a>
          </p>
          <p>
            Telefone/Whatsapp:&nbsp;
            <a
              className="link-inline"
              href="https://api.whatsapp.com/send?phone=31994302079"
              target="_blank"
              rel="noopener noreferrer"
            >
              (31) 99430-2079
            </a>
          </p>
        </div>
        <div className="div-link">
          <a
            className="link"
            href="https://api.whatsapp.com/send?phone=31994302079"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acesse nosso canal de Atendimento
          </a>
        </div>
      </HelpCard>

      <HelpCard title="Manual Next Business" logo={IconeManual}>
        <div className="text-card">
          <p>Alguma dúvida?</p>
          <p>
            No manual do NEXT Business, você encontrará as instruções para utilização de todos os
            recursos e facilidades oferecidos pelo sistema.
          </p>
        </div>
        <div className="div-link">
          <a
            className="link"
            href="http://paivapiovesan.com.br/manualnext/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Leia o manual
          </a>
        </div>
      </HelpCard>

      <HelpCard title="Sobre a Paiva Piovesan" logo={IconeSobreAPP}>
        <div className="text-card">
          <p>
            A Paiva Piovesan tem sua sede no município de Belo Horizonte, estado de Minas Gerais.
            Fundada em dezembro de 1990, a empresa possui a missão de gerar soluções inovadoras,
            eficientes e seguras para simplificar a gestão financeira e a administração de negócios.
          </p>
        </div>
        <div className="div-link">
          <a
            className="link"
            href="http://paivapiovesan.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visite nosso site
          </a>
        </div>
      </HelpCard>

      <HelpCard title="Primeiros passos" logo={IconePrimeirosPassos}>
        <div className="text-card">
          <p>Não sabe por onde começar?</p>
          <p>
            Confira o tutorial ‘Primeiros Passos’, para aprender como iniciar a operação do NEXT
            Business.
          </p>
        </div>
        <div className="div-link">
          <a
            className="link"
            href="http://paivapiovesan.com.br/manualnext/base-manuais/primeiros-passos-business/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aprenda os primeiros passos
          </a>
        </div>
      </HelpCard>
    </div>
  </div>
);

export default Help;
